module.exports = __webpack_public_path__ + "static/media/halloween1.7e6c6d85.jpg";